import { Feature } from "redux/services/config";

import { createLMFeatures } from "utils";

import { useQueryParams } from "./useQueryParams";

import ClusteredPinPlugin from "components/Map/plugins/clustered-pin-control";

interface Props {
  preloadedFeatures?: Feature[];
  clusteredPinControlInstance: React.MutableRefObject<ClusteredPinPlugin | null>;
  onFeatureRouteLoad?: () => void;
}

export const useHandleFeatureRouteLoad = ({
  preloadedFeatures,
  clusteredPinControlInstance,
  onFeatureRouteLoad,
}: Props) => {
  const { queryParams } = useQueryParams();

  const handleFeatureRouteLoad = () => {
    const routeFeatureId = queryParams.get("feature");
    // If the routeFeatureId is present in the URL, we need to display the route for the given feature
    if (routeFeatureId) {
      // Find feature within the features array
      const feature = preloadedFeatures?.find(
        (feature) => feature.properties.lm_id === routeFeatureId,
      );

      if (feature) {
        const clusteredPinControl = clusteredPinControlInstance.current;
        if (!clusteredPinControl) return;

        const lmFeature = createLMFeatures([feature]);
        // Selecting the URL feature can request its route immediately.
        // Start its session before recording the route_request event.
        onFeatureRouteLoad?.();
        clusteredPinControl.updateFeatureLabels(lmFeature, true);
      } else console.warn(`Feature with ID ${routeFeatureId} not found`);

      // Remove the feature query param from the URL after the route has been loaded
      queryParams.delete("feature");
      const newUrl = `${new URL(window.location.href).pathname}?${queryParams.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
  };

  return {
    handleFeatureRouteLoad,
  };
};
